var _style, _ellipse, _path, _path2, _path3, _line, _path4, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuminousIndicator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "15.6px",
    height: "8.8px",
    viewBox: "0 0 15.6 8.8",
    style: {
      enableBackground: "new 0 0 15.6 8.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.3;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st2{stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st4{stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Luminous Indicator") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 7.8,
    cy: 4.4,
    rx: 4.2,
    ry: 4.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.2,7.6c-2.6-2.2-1.5-5.5,0-6.4l2.7,3.3L5.2,7.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.2,6.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.7,1.4c1.9,2.4,2.2,4-0.2,6.3L7.9,4.5L10.7,1.4z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 3.6,
    y1: 4.4,
    x2: 0,
    y2: 4.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M15,1.3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 12.2,
    y1: 4.4,
    x2: 15.6,
    y2: 4.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuminousIndicator);
export default __webpack_public_path__ + "static/media/LuminousIndicator.41133d09fc9a4dfcec9f9128fd36e95b.svg";
export { ForwardRef as ReactComponent };